import * as React from 'react'
import Slider, { sliderClasses } from '@mui/base/Slider'
import { styled, Typography } from '@mui/material'
import { t } from '$i18n'

const parseNumberPartFromLabel = (label: string) => {
  return +label.split('p')[0]
}

export function VideoPreviewCompressionSlider({
  marks,
  onChange,
  value,
}: {
  marks: { value: number; label: string }[]
  onChange: (rate: number) => unknown
  value: number
}) {
  const { value: defaultValue } =
    marks?.find(({ label }) => parseNumberPartFromLabel(label) === value) || {}

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '84px',
        padding: '12px 22px 0 22px',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="body2" color="white">
          {t('sendField.upperQuality')}
        </Typography>
        <Typography variant="body2" color="white">
          {t('sendField.lessVolume')}
        </Typography>
      </div>

      <StyledSlider
        disabled={!marks?.length}
        step={null}
        value={defaultValue}
        onChange={(_, v) => {
          const mark = marks.find(item => item.value === v)
          if (!mark) return
          const { label: selectedLabel } = mark
          const rate = parseNumberPartFromLabel(selectedLabel)
          onChange(rate)
        }}
        marks={marks}
      />
    </div>
  )
}

const StyledSlider = styled(Slider)(
  ({ theme }) => `
  height: 6px;
  width: 100%;
  padding: 16px 0;
  display: inline-block;
  position: relative;
  cursor: pointer;
  touch-action: none;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    opacity: 1;
  }

  &.${sliderClasses.disabled} { 
    pointer-events: none;
    cursor: default;
    color: ${theme.palette.gray};
    opacity: 0.5;
  }

  & .${sliderClasses.rail} {
    display: block;
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 2px;
    background-color: ${theme.palette.semiLightGray};
    opacity: 0.4;
  }

  & .${sliderClasses.track} {
    display: block;
    position: absolute;
    height: 4px;
    border-radius: 2px;
    background-color: ${theme.palette.secondary.main};
  }

  & .${sliderClasses.thumb} {
    position: absolute;
    width: 16px;
    height: 16px;
    margin-left: -6px;
    margin-top: -6px;
    box-sizing: border-box;
    border-radius: 50%;
    outline: 0;
    border: 3px solid ${theme.palette.secondary.main};
    background-color: ${theme.palette.secondary.main};

    }

  }

  & .${sliderClasses.mark} {
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 99%;
    background-color: ${theme.palette.semiLightGray};
    top: 43%;
    transform: translateX(-50%);
  }

  & .${sliderClasses.markActive} {
    background-color: ${theme.palette.secondary.main};
  }

  & .${sliderClasses.markLabel} {
    :first-of-type {
      display: none;
    };
    :last-child {
      display: none;
    };
    font-weight: 500;
    font-size: 12px;
    position: absolute;
    top: 20px;
    transform: translateX(-50%);
    margin-top: 18px;
    color: ${theme.palette.secondary.light}
  }
`,
)
